export enum BookingValidationItems {
  people = 'people',
  tables = 'tables',
  selectedTime = 'selectedTime',
  staffName = 'staffName',
  bookingOptions = 'bookingOptions',
  bookingOptionsPax = 'bookingOptionsPax',
  upsellOptions = 'upsellOptions',
  notChangedStatus = 'notChangedStatus',
  recurringBookingNotConfirmed = 'recurringBookingNotConfirmed',
}

export interface ITabValidationRules {
  selectedTab: number;
  displayErrors: number;
  forceGuestListValidation: boolean;
}

export interface ITabValidationSwitches {
  customerValid: boolean;
  detailsValid: boolean;
  paymentValid: boolean;
  guestListValid: boolean;
  isCovidGuestMode: boolean;
  isBookingOption: boolean;
  isRecurringBooking: boolean;
  bookingOptionsValid: boolean;
}

export enum ValidationErrorType {
  email = 'email',
  phone = 'phone',
  customer = 'customer',
  existingCustomer = 'existingCustomer',
  table = 'table',
  staff = 'staff',
  time = 'time',
  pax = 'pax',
  bookingOptions = 'bookingOptions',
  upsellOptions = 'upsellOptions',
  status = 'status',
  payment = 'payment',
  bookedBy = 'bookedBy',
  recurringBooking = 'recurringBooking',
}

export enum BookingCreatorPanelType {
  bookingDetails = 'bookingDetails',
  customerDetails = 'customerDetails',
  upsellOptions = 'upsellOptions',
  bookingOptions = 'bookingOptions',
  staff = 'staff',
  status = 'status',
  payment = 'payment',
  bookedBy = 'bookedBy',
  recurringBooking = 'recurringBooking',
}

export interface IValidationErrorListItem {
  type: ValidationErrorType;
  msg: string;
  panel?: BookingCreatorPanelType;
}
